import "./App.css";

import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

/* ==========================================================
   PUBLIC WEBSITE PAGES
========================================================== */

import Home from "./pages/website/Home";
import About from "./pages/website/About";
import Membership from "./pages/website/Membership";
import Benefits from "./pages/website/Benefits";
import News from "./pages/website/News";

import Contact from "./pages/website/Contact";
import Register from "./pages/website/Register";

/* ==========================================================
   PAYMENT PAGES
========================================================== */

import MembershipPayment from "./pages/website/MembershipPayment";
import PaymentSuccess from "./pages/website/PaymentSuccess";

/* ==========================================================
   MEMBER LAYOUT
========================================================== */

import MemberLayout from "./pages/member/MemberLayout";

/* ==========================================================
   MEMBER PORTAL PAGES
========================================================== */

import Dashboard from "./pages/member/Dashboard";
import MyProfile from "./pages/member/MyProfile";
import MembershipDetails from "./pages/member/MembershipDetails";
import PaymentHistory from "./pages/member/PaymentHistory";
import IDCard from "./pages/member/IDCard";
import Claims from "./pages/member/Claims";
import MemberDownloads from "./pages/member/Downloads";
import Notifications from "./pages/member/Notifications";
import Support from "./pages/member/Support";
import ReferEarn from "./pages/member/ReferEarn";

/* ==========================================================
   APP
   ABNB SEVA SAMITI & VIDYA CHARITABLE TRUST
========================================================== */

function App() {
  return (
    <BrowserRouter>

      <Routes>

        {/* ==================================================
            PUBLIC WEBSITE
        ================================================== */}

        {/* Home */}
        <Route
          path="/"
          element={<Home />}
        />

        {/* About Us */}
        <Route
          path="/about"
          element={<About />}
        />

        {/* Membership */}
        <Route
          path="/membership"
          element={<Membership />}
        />

        {/* Benefits */}
        <Route
          path="/benefits"
          element={<Benefits />}
        />

        {/* News & Events */}
        <Route
          path="/news-events"
          element={<News />}
        />

        {/* Keep old /news URL working */}
        <Route
          path="/news"
          element={
            <Navigate
              to="/news-events"
              replace
            />
          }
        />

        
        

        {/* Contact */}
        <Route
          path="/contact"
          element={<Contact />}
        />

        {/* Membership Registration */}
        <Route
          path="/register"
          element={<Register />}
        />

        {/* ==================================================
            PAYMENT
        ================================================== */}

        {/* Membership Payment */}
        <Route
          path="/membership-payment"
          element={<MembershipPayment />}
        />

        {/* Payment Success */}
        <Route
          path="/payment-success"
          element={<PaymentSuccess />}
        />

        {/* ==================================================
            MEMBER PORTAL
            COMMON LAYOUT
        ================================================== */}

        <Route element={<MemberLayout />}>

          {/* ================================================
              DASHBOARD
          ================================================ */}

          <Route
            path="/dashboard"
            element={<Dashboard />}
          />

          {/* ================================================
              MY PROFILE
          ================================================ */}

          <Route
            path="/profile"
            element={<MyProfile />}
          />

          {/* ================================================
              MEMBERSHIP DETAILS
          ================================================ */}

          <Route
            path="/membership-details"
            element={<MembershipDetails />}
          />

          {/* ================================================
              PAYMENT HISTORY
          ================================================ */}

          <Route
            path="/payment-history"
            element={<PaymentHistory />}
          />

          {/* ================================================
              ID CARD
          ================================================ */}

          <Route
            path="/id-card"
            element={<IDCard />}
          />

          {/* ================================================
              CLAIMS
          ================================================ */}

          <Route
            path="/claims"
            element={<Claims />}
          />

          {/* ================================================
              MEMBER DOWNLOADS
          ================================================ */}

          <Route
            path="/member-downloads"
            element={<MemberDownloads />}
          />

          {/* ================================================
              NOTIFICATIONS
          ================================================ */}

          <Route
            path="/notifications"
            element={<Notifications />}
          />

          {/* ================================================
              SUPPORT
          ================================================ */}

          <Route
            path="/support"
            element={<Support />}
          />

          {/* ================================================
              REFER & EARN
          ================================================ */}

          <Route
            path="/refer-earn"
            element={<ReferEarn />}
          />

        </Route>

        {/* ==================================================
            FALLBACK
            Any unknown URL goes to HOME
        ================================================== */}

        <Route
          path="*"
          element={
            <Navigate
              to="/"
              replace
            />
          }
        />

      </Routes>

    </BrowserRouter>
  );
}

export default App;